module.exports = __webpack_public_path__ + "static/media/PASSO_A_PASSO_CHATBOT.e77048f9.pdf";